import React from 'react'
import ConversationWidget from '../Components/ConversationWidget/ConversationWidget'
import { useSelector } from 'react-redux';

const ConversationTranscript = () => {
const state = useSelector((state) => state); 
let selectedConversationId = state.SelectedConversationId;
  return (
<div>
  {selectedConversationId == null ?(
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <h3>Listening ...</h3>
    </div>
  ) : <ConversationWidget />}
</div>
  )
}

export default ConversationTranscript
